import { getStaffMemberQueryOptions } from "@packages/api-client/hooks/staffController";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { StaffDetailsNavigation } from "@/routes/_auth/app/_app/org/$orgId/staff/-components/StaffDetailsNavigation";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/staff/$staffId",
)({
	loader: async ({ context, params }) => {
		const { orgId, staffId } = params;

		// Preload staff member data
		context.queryClient.ensureQueryData(
			getStaffMemberQueryOptions(orgId, staffId),
		);

		return { orgId, staffId };
	},
	component: StaffDetailsLayout,
});

function StaffDetailsLayout() {
	const { t } = useTranslation();
	const location = useLocation();

	// Determine active tab based on current route
	const getActiveTab = (): "edit" | "permissions" => {
		const pathname = location.pathname;
		if (pathname.endsWith("/permissions")) return "permissions";
		return "edit"; // default to edit
	};

	return (
		<div className="flex flex-col h-full">
			<PageHeader
				title={t("staff.navigation.title")}
				description={t("staff.navigation.description")}
				showBackButton={true}
				backButtonText={t("common.back")}
				hideOnMobile={false}
			/>

			{/* Main content area with side navigation */}
			<div
				className="flex-1 flex h-[calc(100vh-4rem)] min-h-0 overflow-hidden"
				data-testid="staff-details-container"
			>
				{/* Side Navigation */}
				<StaffDetailsNavigation activeTab={getActiveTab()} />

				{/* Main Content Area */}
				<div
					className="flex-1 p-3 md:p-4 bg-base-200 min-h-0 overflow-auto"
					data-testid="staff-details-main-content-area"
				>
					<Outlet />
				</div>
			</div>
		</div>
	);
}
